/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Box } from '@atlaskit/primitives';
import { N500 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var footerInformationStyles = css({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  minWidth: 0,
  minHeight: "var(--ds-space-300, 24px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  '& > p, & > div:first-child': {
    color: "var(--ds-text-subtle, ".concat(N500, ")"),
    fontSize: '11px',
    marginTop: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > span': {
    marginTop: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-050, 4px)",
    marginBottom: "var(--ds-space-050, 4px)"
  }
});
/**
 * Custom disclaimer to be displayed in the footer.
 *
 * @todo: Are we really need custom disclaimer?
 *        We should check if it's used in any product and remove it support if not.
 */
export function CustomDisclaimer(_ref) {
  var disclaimer = _ref.disclaimer;
  return jsx("div", {
    css: footerInformationStyles
  }, jsx(Box, {
    testId: "custom-disclaimer"
  }, jsx(Tooltip, {
    content: disclaimer.tooltip,
    position: "top"
  }, disclaimer.url ? jsx("a", {
    href: disclaimer.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, disclaimer.text) : jsx("span", null, disclaimer.text))));
}